import { defineComponent as _defineComponent } from 'vue'
import { DEFAULT_MAX_GRADE } from 'bits/surface_settings_helper'
import { __ } from 'bits/intl'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import OzContainedButton, { OzContainedButtonColorScheme } from 'library/v4/components/OzContainedButton.vue'
import SurfaceDropdownReactionBase from 'vuecomponents/SurfaceDropdownReactionBase.vue'
import { useReactionsStore } from 'pinia/surface_reactions'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from 'pinia/dark_mode'
import { useSurfaceStore } from 'pinia/surface'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceDropdownReactionGrade',
  props: {
    usageContext: null
  },
  setup(__props: any) {

const props = __props as {
  usageContext: 'postView' | 'postExpandedView'
}



const { accumulatedReactionsByWishId, originalReactionData, currentReactionData, postIdBeingReactedTo } = storeToRefs(
  useReactionsStore(),
)
const accumulatedReaction = computed(
  () =>
    accumulatedReactionsByWishId.value[postIdBeingReactedTo.value as number] || {
      sum: 0,
      totalReactionsCount: 0,
    },
)
const maxGrade = computed(
  () => currentReactionData?.value?.max_value ?? originalReactionData?.value?.max_value ?? DEFAULT_MAX_GRADE,
)
const numpadError = computed(() => {
  if (numpadInputValue.value && numpadInputValue.value > maxGrade.value) {
    return __('Overachiever! The maximum grade is %{maxGrade}', { maxGrade: maxGrade.value })
  }
  return null
})
const numpadMessage = computed(() => {
  if (numpadError.value) {
    return numpadError.value
  }

  if (numpadInputValue.value === maxGrade.value) {
    return __('Perfect!')
  }

  return ''
})
const myGrading = computed(() => accumulatedReaction.value?.userReaction?.value)

/**
 * For modal mode
 */
const numpadInputValue = ref<number | null>(null)
const shouldOverWriteNumpadInput = ref(false)
const updatingNumpadInputValue = ref(false)
function numpadAppendNumber(num: number): void {
  // use updatingNumpadInputValue as a guard to prevent multiple updates run at the same time when user tap too fast
  if (updatingNumpadInputValue.value || !!numpadError.value) {
    return
  }
  updatingNumpadInputValue.value = true
  if (shouldOverWriteNumpadInput.value) {
    numpadInputValue.value = 0
  }
  numpadInputValue.value = (numpadInputValue.value || 0) * 10 + num
  shouldOverWriteNumpadInput.value = false
  updatingNumpadInputValue.value = false
}

function numpadDeleteLastNumber(): void {
  // use updatingNumpadInputValue as a guard to prevent multiple updates run at the same time when user tap too fast
  if (updatingNumpadInputValue.value) {
    return
  }
  updatingNumpadInputValue.value = true
  shouldOverWriteNumpadInput.value = false
  if (numpadInputValue.value !== null) {
    numpadInputValue.value = Math.floor(numpadInputValue.value / 10)
    if (numpadInputValue.value === 0) {
      numpadInputValue.value = null
    }
  }
  updatingNumpadInputValue.value = false
}

const isDarkMode = storeToRefs(useDarkModeStore()).isDarkMode
const colorScheme = storeToRefs(useSurfaceStore()).colorScheme
const isPadletColorSchemeDark = computed(() => {
  return props.usageContext === 'postExpandedView' ? isDarkMode.value : colorScheme.value === 'dark'
})

const { createReaction, updateReaction, deleteReaction, stopEditingReaction } = useReactionsStore()
function submitNumpadGrade(): void {
  if (numpadInputValue.value) {
    if (myGrading.value != null) {
      updateReaction({ postId: postIdBeingReactedTo.value, value: numpadInputValue.value })
    } else {
      createReaction({ postId: postIdBeingReactedTo.value, value: numpadInputValue.value })
    }
  } else {
    deleteReaction({ postId: postIdBeingReactedTo.value })
  }
  stopEditingReaction()
}

function grade(event): void {
  const value = parseInt(event.currentTarget.value, 10)
  if (myGrading.value != null) {
    updateReaction({ postId: postIdBeingReactedTo.value, value })
  } else {
    createReaction({ postId: postIdBeingReactedTo.value, value })
  }
  stopEditingReaction()
}

function ungrade(): void {
  deleteReaction({ postId: postIdBeingReactedTo.value })
  stopEditingReaction()
}

return { __sfc: true,props, accumulatedReactionsByWishId, originalReactionData, currentReactionData, postIdBeingReactedTo, accumulatedReaction, maxGrade, numpadError, numpadMessage, myGrading, numpadInputValue, shouldOverWriteNumpadInput, updatingNumpadInputValue, numpadAppendNumber, numpadDeleteLastNumber, isDarkMode, colorScheme, isPadletColorSchemeDark, createReaction, updateReaction, deleteReaction, stopEditingReaction, submitNumpadGrade, grade, ungrade, __, OzIcon, OzTextButton, OzTextButtonColorScheme, OzContainedButton, OzContainedButtonColorScheme, SurfaceDropdownReactionBase }
}

})